import { render, staticRenderFns } from "./BrandNotes.vue?vue&type=template&id=216bf7e0"
import script from "./BrandNotes.vue?vue&type=script&lang=js"
export * from "./BrandNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports